import * as React from "react";
import {
  withStyles,
  AppBar,
  Toolbar,
  Typography,
  Avatar,
  ListItemText,
  Checkbox,
  Button,
  FormControlLabel,
  IconButton,
  TextField,
  Input
} from "@material-ui/core";
import { Chat, Message, Case } from "../../api/classes";
import TwitterTweetEmbed from "../../components/TwitterEmbed";
import BackIcon from "@material-ui/icons/ArrowBack";
import CasePicker from "../../components/dialogs/casePicker";
import {
  DubitoAPI,
  SendMessageRequest,
  MessageAttachmentRequest
} from "../../api/DubitoAPI";
import { DubitoSvc } from "../../api";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import FolderIcon from "@material-ui/icons/Folder";
import TemplateIcon from "@material-ui/icons/Assignment";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Close";

import { Link } from "react-router-dom";
import LinkMeta from "../cases/components/linkMeta";
import CaseFile from "../cases/components/file";
import MessageTemplatePicker from "src/components/dialogs/messageTemplatePicker";
import Loading from "../../components/loading";
import * as moment from "moment";
import { getChatUsers, DEFAULT_AVATAR } from "src/auth/auth";
import users from "../users";
interface Props {
  classes: any;
  chat: Chat;
  messages: Message[];
  showBack?: boolean;
  onBack?: () => void;
  bindMessages: (caseID: number, messageIds: number[], callback?) => void;
  fetchChatsAfter: (id) => void;
  chatID: string;
}
const styles = {
  root: {
    flex: 1,
    backgroundColor: "#F5F5F5"
  }
};
interface State {}
class MessageDetail extends React.Component<Props, State> {
  state = {
    selected: [],
    showCasePicker: false,
    showTemplateChooser: false,
    text: "",
    files: [],
    links: [],
    messageSending: false,
    chat: undefined,
    messages: undefined,
    selfLoad: false
  };
  scrollRef;
  componentWillMount() {
    if (this.props.chat) {
      this.fetchMessageDetails(this.props.chat.chatID);

      setTimeout(() => {
        if (this.scrollRef) {
          this.scrollRef.scrollTop =
            this.scrollRef.scrollHeight + this.scrollRef.offsetHeight;
        }
      }, 1);
    } else {
      this.fetchChat(this.props.chatID);
      this.fetchMessageDetails(this.props.chatID);
    }
  }
  fetchChat = id => {
    DubitoSvc.getMessages({ sender_id: id }).then(res => {
      console.warn(res.messages.reverse());
      const user = getChatUsers().find(i => i.sender_id === id);
      const chat = {
        account_name: user && user.account_name,
        account_picture: user && user.account_picture,
        source:
          res.messages.length > 0 &&
          res.messages[res.messages.length - 1].source
      };
      this.setState({ chat: chat, messages: res.messages, selfLoad: true });
    });
  };
  componentWillReceiveProps(next: Props) {
    if (
      next.chat &&
      (!this.props.chat || next.chat.chatID !== this.props.chat.chatID)
    ) {
      this.fetchMessageDetails(next.chat.chatID);
      this.setState({ selected: [], selfLoad: false });
    }

    if (
      (next.chat &&
        (this.scrollRef &&
          this.props.messages.length < next.messages.length)) ||
      (!next.chat ||
        !this.props.chat ||
        next.chat.chatID !== this.props.chat.chatID)
    ) {
      setTimeout(() => {
        if (this.scrollRef) {
          this.scrollRef.scrollTop =
            this.scrollRef.scrollHeight + this.scrollRef.offsetHeight;
        }
      }, 300);
    }
    if (
      this.props.chatID !== next.chatID &&
      (!next.chat || next.chat.chatID !== next.chatID)
    ) {
      this.fetchChat(next.chatID);
      this.fetchMessageDetails(next.chatID);
      this.setState({ selected: [], selfLoad: false });
      console.log(next.chat, next.chatID);
    }
  }
  fetchMessageDetails(chatID) {
    DubitoSvc.getMessageAttachments({
      sender_id: chatID
    } as MessageAttachmentRequest).then(res => {
      //console.log(res);
      if (res.files || res.links) {
        this.setState({ links: res.links, files: res.files });
      }
    });
  }
  assignToCase(caseID) {
    this.props.bindMessages(caseID, this.state.selected, messageIds => {
      if (this.state.selfLoad) {
        let messages = this.state.messages;
        messages = messages.map(i => {
          if (messageIds.find(s => s === i.id)) {
            i.case_id = caseID;
          }
          return i;
        });
        this.setState({ messages: messages });
      }
    });
    this.setState({ showCasePicker: false, selected: [] });
  }
  sendMessage = () => {
    this.setState({ messageSending: true });

    let { chat } = this.props;
    if (!chat) {
      chat = this.state.chat;
    }
    const req = {} as SendMessageRequest;
    if (this.state.text.length < 2) {
      return;
    }
    req.text = this.state.text;
    req.source = chat.source;
    if (chat.is_reply === 1) {
      req.sender_id = chat.sender_id;
      req.recipient_id = chat.recipient_id;
    } else {
      req.sender_id = chat.recipient_id;
      req.recipient_id = chat.sender_id;
    }
    req.account_name = chat.account_name;
    req.account_picture = chat.account_picture;
    req.external_message_id = chat.external_message_id;
    DubitoSvc.sendMessage(req)
      .then(res => {
        if (res.success) {
          this.refresh();
          this.setState({ text: "", messageSending: false });
        } else {
          this.setState({ messageSending: false });
        }
      })
      .catch(() => {
        this.setState({ messageSending: false });
      });
  };
  renderLinks(messageId: number) {
    if (this.state.links) {
      return this.state.links.map(a => {
        if (a.message_id === messageId) {
          return (
            <div style={{}}>
              <LinkMeta link={a} />
            </div>
          );
        }
      });
    }
  }
  renderFiles(messageId: number) {
    if (this.state.files) {
      return this.state.files.map(a => {
        if (a.message_id === messageId) {
          if (a.file_type === "image") {
            return (
              <div style={{}}>
                <CaseFile file={a} />
              </div>
            );
          }
        }
      });
    }
  }
  renderMessage(i: Message) {
    if (i.is_reply) {
      return (
        <div
          key={i.id}
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: 64,
            maxWidth: "95%"
          }}
        >
          <span
            style={{
              alignSelf: "flex-end",
              backgroundColor: "#DCF8C6",
              borderRadius: 16,
              padding: 8,
              marginBottom: 8
            }}
          >
            {i.text}
          </span>
          <Typography
            variant="caption"
            style={{
              marginLeft: 12,
              alignSelf: "flex-end",
              marginBottom: 12
            }}
          >
            {moment(i.created_at).format("LLL")}
          </Typography>
        </div>
      );
    } else {
      return (
        <div
          /*           key={i.external_message_id}
           */ style={{
            alignSelf: "flex-start",
            marginBottom: 8,
            display: "flex",
            flexDirection: "column",
            minHeight: 30,
            width: "95%"
          }}
        >
          <div
            style={{
              alignSelf: "flex-start",
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            {i.case_id === null ? (
              <Checkbox
                key={i.id}
                color="primary"
                checked={
                  this.state.selected.length !== 0 &&
                  this.state.selected.find(e => e === i.id)
                }
                onChange={(e, v) => {
                  let sel = this.state.selected;
                  if (v) {
                    sel.push(i.id);
                  } else {
                    const index = sel.findIndex(e => e === i.id);
                    sel.splice(index, 1);
                  }
                  this.setState({ selected: sel });
                }}
                disabled={i.case_id !== null}
              />
            ) : (
              <Link
                to={"/case/" + i.case_id}
                style={{ textDecoration: "none" }}
              >
                <FolderIcon style={{ margin: 12 }} color="action" />
              </Link>
            )}
            {i.source === "twitter:mention" ? (
              <TwitterTweetEmbed
                text={i.text}
                tweetId={i.external_message_id}
              />
            ) : (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  style={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: 16,
                    paddingLeft: 8,
                    paddingRight: 8,
                    paddingTop: 4,
                    paddingBottom: 4,
                    wordBreak: "break-word"
                  }}
                >
                  {i.text}
                </span>
                {this.renderLinks(i.id)}
                {this.renderFiles(i.id)}
              </div>
            )}
          </div>
          <Typography variant="caption" style={{ marginLeft: 48 }}>
            {moment(i.created_at).format("LLL")}
          </Typography>
        </div>
      );
    }
  }
  renderMessages() {
    if (this.props.chat && !this.state.selfLoad) {
      return this.props.messages
        .filter(i => {
          return (
            (i.recipient_id === this.props.chat.recipient_id &&
              i.sender_id === this.props.chat.sender_id) ||
            (i.recipient_id === this.props.chat.sender_id &&
              i.sender_id === this.props.chat.recipient_id)
          );
        })
        .reverse()
        .map(i => {
          return this.renderMessage(i);
        });
    } else if (this.state.messages) {
      return this.state.messages.map(i => {
        return this.renderMessage(i);
      });
    }
  }
  refresh = () => {
    DubitoSvc.getMessages({
      newestMessageId: this.props.messages[0].id
    }).then(res => {
      //   this.setState({ refreshing: false, lastRefreshTime: moment() });
      this.props.fetchChatsAfter(res.messages);
    });
  };
  render() {
    const { classes } = this.props;
    let chat = undefined;
    if (this.props.chat) {
      chat = this.props.chat;
    } else if (this.state.chat) {
      chat = this.state.chat;
    }
    if (!chat) {
      return <Loading />;
    }
    return (
      <div
        className={classes.root}
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1
        }}
      >
        {this.state.selected.length > 0 ? (
          <AppBar position="static" color="primary">
            <Toolbar color="primary">
              <IconButton
                onClick={() => {
                  this.setState({ selected: [] }, () => {
                    this.forceUpdate();
                  });
                }}
              >
                <CancelIcon style={{ color: "white" }} />
              </IconButton>
              <Typography variant="title" style={{ color: "white", flex: 1 }}>
                {this.state.selected.length} selected
              </Typography>
              <Button
                onClick={() => this.setState({ showCasePicker: true })}
                color="inherit"
              >
                Assign to a Case
              </Button>
            </Toolbar>
          </AppBar>
        ) : (
          <AppBar position="static" color="default">
            <Toolbar>
              {this.props.showBack && (
                <IconButton onClick={this.props.onBack}>
                  <BackIcon />
                </IconButton>
              )}
              <Avatar
                src={chat && chat.account_picture}
                onError={(e: any) => {
                  e.target.onerror = null;
                  e.target.src = DEFAULT_AVATAR;
                }}
              />
              <ListItemText
                primary={chat && chat.account_name}
                secondary={chat && chat.source}
              />
            </Toolbar>
          </AppBar>
        )}
        <CasePicker
          open={this.state.showCasePicker}
          onSelect={caseID => this.assignToCase(caseID)}
          onClose={() => this.setState({ showCasePicker: false })}
        />
        <MessageTemplatePicker
          open={this.state.showTemplateChooser}
          onSelect={text =>
            this.setState({ text: text, showTemplateChooser: false })
          }
          onClose={() => this.setState({ showTemplateChooser: false })}
        />
        <div
          ref={r => (this.scrollRef = r)}
          style={{
            flex: 1,
            overflowY: "scroll",
            flexDirection: "column",
            paddingTop: 16,
            paddingLeft: 16,
            paddingRight: 16
          }}
        >
          {!this.state.selfLoad && (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 12
              }}
            >
              <Button
                variant="flat"
                size="small"
                color="primary"
                style={{
                  textTransform: "none",
                  backgroundColor: "white",
                  borderRadius: 16,
                  paddingLeft: 16,
                  paddingRight: 16
                }}
                onClick={() => this.fetchChat(this.props.chat.chatID)}
              >
                Check Previous Messages
              </Button>
            </div>
          )}
          {this.renderMessages()}
        </div>
        <div
          style={{ display: "flex", padding: 12, backgroundColor: "#F4F1EE" }}
        >
          <IconButton
            onClick={() => this.setState({ showTemplateChooser: true })}
          >
            <TemplateIcon />
          </IconButton>
          <Input
            style={{
              backgroundColor: "white",
              borderRadius: 24,
              marginRight: 12,
              marginTop: 4,
              marginBottom: 4,
              paddingLeft: 12,
              paddingTop: 12,
              flex: 1
            }}
            multiline
            value={this.state.text}
            onChange={e => this.setState({ text: e.target.value })}
            inputProps={{
              flex: 1
              // verticalTextAlign: "center"
            }}
            disableUnderline
            placeholder="Type Your Message"
          />
          <IconButton
            onClick={this.sendMessage}
            disabled={this.state.messageSending}
          >
            <SendIcon />
          </IconButton>
        </div>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    messages: state.cases.messages
  }),
  dispatch => ({
    bindMessages: (caseID: number, messageIds: number[], callback): any =>
      dispatch(actions.bindMessages(caseID, messageIds, callback)),
    fetchChatsAfter: (id): any => dispatch(actions.fetchChatsAfter(id))
  })
)(withStyles(styles)(MessageDetail));



// WEBPACK FOOTER //
// ./src/pages/messages/detail.tsx